import { render, staticRenderFns } from "./saleCategoriesRepresentiveTable.vue?vue&type=template&id=032fbb7a&"
import script from "./saleCategoriesRepresentiveTable.vue?vue&type=script&lang=js&"
export * from "./saleCategoriesRepresentiveTable.vue?vue&type=script&lang=js&"
import style0 from "./saleCategoriesRepresentiveTable.vue?vue&type=style&index=0&id=032fbb7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports